import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Modal, Typography, Form, Input, Row, Col, Select} from 'antd';
import BaseSelect from 'components/Elements/BaseSelect';
import axios from 'axios';
import { toast } from 'react-toastify';

const { Title } = Typography;

const UserUpdateForm = (props) => {
	const { record, visible, onClose, onSubmit } = props;
	const [roles, setRoles] = useState([]);
	const [formKey, setFormKey] = useState(Date.now());
	const [loading, setLoading] = useState(false);
	const [formRef] = Form.useForm();
	const token = localStorage.getItem('token');

	useEffect(() => {
		if (visible) {
			// Pre-fill form with default values
			const botIframe = record.config?.notification?.whatsapp?.settings?.bot_iframe;
			const chatIframe = record.config?.notification?.whatsapp?.settings?.chat_iframe;
			const defaultValues = {
				...record,
				whatsapp_chat_iframe: chatIframe,
				whatsapp_bot_iframe: botIframe,
				role: record.role?.id || record.role,
			};
			console.log("Setting Form Values:", defaultValues);

			formRef.setFieldsValue(defaultValues);
		}
	}, [visible, record, token, formRef]);

	// const onScrollEnd = () => {
	// 	setQuery((preState) => {
	// 		return { ...preState, page: preState.page + 1 };
	// 	});
	// };

	// ✅ API call to update user
	const updateUser = async (id, data) => {
		const response = await axios.post(
			`https://billpay.mtmpay.in/Admin/api/admin/update-bill-category/${id}`,
			data,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);
		return response.data;
	};

	const onSubmitData = () => {
		formRef.validateFields().then(async (data) => {
			try {
				setLoading(true);
				await updateUser(record._id || record.id, data);
				toast.success('User updated successfully!');
				onCancel();
				onSubmit(); // notify parent to refresh data or close modal
			} catch (err) {
				toast.error(err.response?.data?.message || 'Something went wrong');
				console.log(err);
			} finally {
				setLoading(false);
			}
		});
	};

	const onCancel = () => {
		formRef.resetFields();
		onClose();
	};

	return (
		<Modal
			title={'Update User'}
			open={visible}
			closable={false}
			onCancel={onCancel}
			onOk={onSubmitData}
			okButtonProps={{ loading }}
			okText="Submit"
		>
			<Form layout="vertical" form={formRef} key={formKey}>
				<Row gutter={[16, 16]}>
					<Col span={12}>
						<Form.Item name="name" label="Name" rules={[{ required: true }]}>
							<Input />
						</Form.Item>
					</Col>
					<Col lg={12} md={12} sm={24} xs={24}>
						<Form.Item
							name="status"
							label="Status"
							initialValue={1}
						>
							<Select>
								<Select.Option value={1}>Active</Select.Option>
								<Select.Option value={0}>Inactive</Select.Option>
							</Select>
						</Form.Item>
					</Col>


				</Row>
			</Form>
		</Modal>
	);
};

UserUpdateForm.propTypes = {
	record: PropTypes.object.isRequired,
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSubmit: PropTypes.func.isRequired,
};

export default UserUpdateForm;
